import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Input } from '@ui/components/Input';

export function TelegramInput() {
  const { control } = useFormContext<{ telegramChannel: string }>();
  return (
    <FormRow>
      <FormLabel>Telegram</FormLabel>
      <FormInput>
        <Controller
          name="telegramChannel"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <Input leftLabel="t.me/" value={value} onChange={onChange} disabled={disabled} />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
